import { AfterViewInit, Component, computed, ElementRef, HostListener, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatRowDef, MatTableDataSource } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { CdkScrollable, ScrollingModule } from '@angular/cdk/scrolling';
import { LabelService } from '../../../services/label.service';
import { CommonService } from '../../../services/common.service';
import { SharedDataService } from '../../../services/shared-data.service';
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as Types from '../../../shared/types';
import { convertConversationsToRowsColumns, transformTestToFilters } from '../../../shared/appUtil';
import { Labels } from '../../../shared/label.types';
import { FilterService } from '../../../services/filter.service';
import { debounceTime, Subscription } from 'rxjs';
import { IntersectionObserverDirective } from '../../../directives/intersection-observer.directive';
import { NotificationService } from '../../../services/notification.service';
import { ApiLoadingService } from '../../../services/api-loading.service';
import { ColumnMode, NgxDatatableModule } from '@m3rlin94/ngx-datatable';
import { SentimentClassPipe } from './pipes/sentiment-class-pipe.pipe';
import { FormattedValuePipe } from './pipes/formatted-value-pipe.pipe';
import { TruncateTopicPipe } from './pipes/truncate-topic-pipe.pipe';
import { FormatDatePipe } from './pipes/format-date-pipe.pipe';
import { TopicClassPipe } from './pipes/topic-class-pipe.pipe';
import { SentimentTextPipe } from './pipes/sentiment-text-pipe.pipe';
import { FormatTimestampPipe } from './pipes/format-timestamp-pipe.pipe';
import { DataViewTimestampFormatPipe } from './pipes/data-view-timestamp-format.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { isClusteredInsightColumn } from '../../../shared/constant';

@Component({
  selector: 'app-tabular-view',
  standalone: true,
  imports: [
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatTooltipModule,
    MatSelectModule,
    FormsModule,
    SkeletonLoaderComponent,
    ToastrModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    ClipboardModule,
    DragDropModule,
    ScrollingModule,
    MatRowDef,
    IntersectionObserverDirective,
    NgxDatatableModule,
    SentimentClassPipe,
    FormattedValuePipe,
    TruncateTopicPipe,
    FormatDatePipe,
    TopicClassPipe,
    SentimentTextPipe,
    FormatTimestampPipe,
    DataViewTimestampFormatPipe,
    LoadingComponent,
  ],
  templateUrl: './tabular-view.component.html',
  styleUrls: ['./tabular-view.component.scss'],
})
export class TabularViewComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(CdkScrollable)
  scrollable!: CdkScrollable;

  @Input() totalRow: any;

  tableViewBody: Types.TableViewBody = {} as Types.TableViewBody;
  // searchBody: Types.TableViewBody = {} as Types.TableViewBody;
  ELEMENT_DATA: Types.PeriodicElement[] = [];
  dataSource = new MatTableDataSource<Types.PeriodicElement>(this.ELEMENT_DATA);
  apiData: any;
  apiTotalRow!: number;
  labels: Labels = {} as Labels;
  tableHeaders: Types.ColumnHeaders[] = [];
  hiddenColumns: string[] = [];
  selectedColumns: string[] = [];
  newSelectedColumns: string[] = ['index', ...this.selectedColumns];
  topics: string[] = [];
  item: any = {};
  loaderFlag: boolean = true;
  isLoading = false;
  draggingColumnIndex: number | null = null;
  loadingData = false; // To prevent multiple requests
  loadingMorePageData: boolean = false;
  isInitialized: boolean = false; // Flag to check if ngOnInit is completed
  filterDataArray: Types.FilterCondition[] = [];
  pageSize: number = 50;
  pageNumber: number = 1;
  totalCount: number = 0;
  ColumnMode = ColumnMode;
  rows: { [key: string]: string }[] = [];
  columns: { prop: string | undefined; name?: string }[] = [];
  reorderedColumn: string | null = null;
  searchText: string = '';
  apiLoading = true;
  protected _tableViewFlag = computed<boolean>(() => this.sharedDataService.tableViewFlagStatus());
  private subscription: Subscription | undefined;
  private filterRefreshSubscription: Subscription | undefined;
  private timezoneChangeSubscription: Subscription | undefined;
  private searchTermSubscription: Subscription | undefined;
  private isViewSwitching = false;
  private hasLoadedData = false;
  private isLoadingData = false;

  /** True when table data is being fetched (any refresh, filter, load more). */
  get isTableDataLoading(): boolean {
    return this.isLoadingData || this.apiLoadingService.isComponentLoading('table');
  }

  constructor(
    private snackBar: MatSnackBar,
    public sharedDataService: SharedDataService,
    public commonService: CommonService,
    public labelService: LabelService,
    private toastr: ToastrService,
    private clipboard: Clipboard,
    private filterService: FilterService,
    private notificationService: NotificationService,
    private apiLoadingService: ApiLoadingService,
    private el: ElementRef
  ) {}

  setViewSwitching(switching: boolean): void {
    this.isViewSwitching = switching;
  }


  resetLoadingState(): void {
    this.isLoadingData = false;
  }

  ngOnInit() {
    this.filterDataArray = this.filterService.getFilterConditionDataValue();

    // Reset the flags when component initializes
    this.hasLoadedData = false;
    this.isLoadingData = false;

    // Initialize sessionStorage and cross-tab communication (same-tab via custom events)
    this.setupCrossTabCommunication();
    this.loadSelectionFromSession();

    this.labelService.getLabelData().subscribe((data) => {
      this.labels = data?.labels ?? {};
    });

    this.sharedDataService.getColumnNames().subscribe((names) => {
      this.tableHeaders = names;
    });

    this.sharedDataService
      .getSelectedColumns()
      .pipe(debounceTime(200))
      .subscribe((columns) => {
        const columnsSet: Set<string> = new Set(columns);
        const convertToColumnArray: {
          prop: string;
          name?: string;
        }[] = [];

        this.tableHeaders.forEach((header) => {
          if (columnsSet.has(header.name)) {
            convertToColumnArray.push({
              prop: header.key,
              name: header.name,
            });
          }
        });

        this.columns = [...convertToColumnArray];
      });

    this.commonService.getLoaderFlag().subscribe((flag) => {
      if (this.isInitialized) {
        this.loaderFlag = flag;
      }
    });

    this.allRows = this.commonService.filteredDataSource; // Load all data initially, but only render visible ones
    this.commonService.headers = this.tableHeaders;
    this.commonService.displayedColumns = this.commonService.getHeaderNames(this.tableHeaders);
    this.apiData = this.sharedDataService.getApiData();
    this.apiTotalRow = this.sharedDataService.getApiTotalRow();

    this.dataSource.data = this.apiData || [];
    this.commonService.dataSource = new MatTableDataSource(this.apiData || []);
    this.commonService.filteredDataSource = new MatTableDataSource(this.apiData || []);
    this.sharedDataService.setSelectedColumns();

    // Set isInitialized to true once ngOnInit logic has completed
    this.isInitialized = true;

    // Subscribe to the refresh data status to trigger API calls
    this.filterRefreshSubscription = this.filterService.getRefreshDataStatus().subscribe((status) => {
      // Only trigger API calls if we're in table view (not chart view) and component is initialized
      if (status && this._tableViewFlag() && this.isInitialized) {

        // Add a small delay to prevent race conditions with other components
        setTimeout(() => {
          // Double-check we're still in table view after the delay
          if (this._tableViewFlag() && !this.isLoadingData) {
            // Reset loading state when filters are applied
            this.resetLoadingState();
            this.loaderFlag = true;
            this.pageNumber = 1;
            // Clear selections when filters are applied
            this.clearSelections();

            // Call appropriate function based on searchText
            this.fetchTableValueAPIData(this.pageSize, this.pageNumber);
            this.hasLoadedData = true;
          }
        }, 50); // Small delay to prevent race conditions
      }
    });

    this.subscription = this.sharedDataService.getDateRange().subscribe((date) => {
      this.tableViewBody = {
        start_date: date.startAPIDate,
        end_date: date.endAPIDate,
        filters: [],
        search_term: this.searchText,
      };

      if (date?.startAPIDate && date.dateSelected) {
        this.apiLoading = true;
        this.pageNumber = 1;
        // Clear selections when date range changes
        this.clearSelections();
        this.fetchTableValueAPIData(this.pageSize, this.pageNumber);
        this.hasLoadedData = true;
      }
    });

    // Listen for timezone changes and trigger API calls
    this.timezoneChangeSubscription = this.sharedDataService.getTimezoneChange().pipe(
      debounceTime(300) // Debounce to prevent rapid successive calls
    ).subscribe((timezone) => {
      this.tableViewBody.timeZone = timezone;

      // Only trigger API calls if we have valid date range and are in table view
      if (this.tableViewBody.start_date && this.tableViewBody.end_date && this._tableViewFlag()) {

        // Reset loading state before calling API
        this.isLoadingData = false;
        this.apiLoading = true;
        this.pageNumber = 1;

        // Clear selections when timezone changes
        this.clearSelections();
        this.fetchTableValueAPIData(this.pageSize, this.pageNumber);
        this.hasLoadedData = true;
      }
    });

    // Subscribe to search text updates
    this.searchTermSubscription = this.sharedDataService.getSearchTerm$().subscribe((text) => {
      if (text.trim()) {
        this.loaderFlag = true;
        this.searchText = text;
        this.pageNumber = 1;
        this.tableViewBody.search_term = this.searchText;
        // Clear selections when search is performed
        this.clearSelections();
        this.fetchTableValueAPIData(this.pageSize, this.pageNumber);
      } else if (this.searchText.length) {
        this.loaderFlag = true;
        this.searchText = '';
        this.tableViewBody.search_term = this.searchText;
        // Clear selections when search is cleared
        this.clearSelections();
        this.fetchTableValueAPIData(this.pageSize, this.pageNumber);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['this.commonService.rowValue']) {
      this.commonService.getPageRange();
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.commonService.filteredDataSource.paginator = this.paginator;
    this.commonService.filteredDataSource.sort = this.sort;
    this.commonService.tableColumnSearchKey = 'Summary';

    // this.scrollable.elementScrolled().subscribe(() => this.onTableScroll());
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.filterRefreshSubscription) {
      this.filterRefreshSubscription.unsubscribe();
    }
    if (this.timezoneChangeSubscription) {
      this.timezoneChangeSubscription.unsubscribe();
    }
    if (this.searchTermSubscription) {
      this.searchTermSubscription.unsubscribe();
    }

    // Save current selection before component is destroyed
    if (this.selectedRows.size > 0) {
      this.saveSelectionToSession();
    }

    // Clear hovered rows to prevent memory leaks
    this.hoveredRows.clear();

    // Remove event listeners
    window.removeEventListener('storage', this.handleStorageChange.bind(this));
    window.removeEventListener('tabularViewSelectionChange', this.handleCustomStorageEvent.bind(this));
  }

  // Handle page unload to save data
  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    if (this.selectedRows.size > 0) {
      this.saveSelectionToSession();
    }
  }

  onColumnReorder(event: any) {
    this.reorderedColumn = event.columns[event.newIndex].prop;
  }

  getColumnWidth(prop: string | undefined): number {
    if (!prop) return 380;
    if (prop === 'Topics' || prop === 'TopicsClustered') return 640;
    if (prop === 'Summary') return 520;
    return 380;
  }

  isClusteredColumn(prop: string | undefined): boolean {
    return isClusteredInsightColumn(prop);
  }

  getClusterCellValues(raw: unknown): string[] {
    if (raw == null || raw === '' || raw === 'NA' || raw === 'null') return [];
    if (Array.isArray(raw)) {
      return raw.map((value) => String(value).trim()).filter((value) => value && value !== 'NA' && value !== 'null');
    }
    return String(raw)
      .split('|')
      .map((value) => value.trim())
      .filter((value) => value && value !== 'NA' && value !== 'null');
  }

  copyToClipboard(value: string) {
    this.clipboard.copy(value);
  }

  handleCellClick() {
  }

  loadInitialData() {
    this.isLoading = true;
  }

  readonly headerHeight = 50;
  readonly rowHeight = 55;
  readonly pageLimit = 50;
  onScroll(offsetY: number) {
    // total height of all rows in the viewport
    const viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;

    // check if we scrolled to the end of the viewport
    if (!this.isLoading && offsetY + viewHeight >= this.rows.length * this.rowHeight) {
      // total number of results to load
      let limit = this.pageLimit;

      // check if we haven't fetched any results yet
      if (this.rows.length === 0) {
        // calculate the number of rows that fit within viewport
        const pageSize = Math.ceil(viewHeight / this.rowHeight);

        // change the limit to pageSize such that we fill the first page entirely
        // (otherwise, we won't be able to scroll past it)
        limit = Math.max(pageSize, this.pageLimit);
      }
      this.loadPage(limit);
    }
  }

  private loadPage(limit: number) {
    // set the loading flag, which serves two purposes:
    // 1) it prevents the same page from being loaded twice
    // 2) it enables display of the loading indicator
    if (this.totalCount > this.pageNumber * this.pageSize) {
      // this.loadingMorePageData = true;
      this.pageNumber += 1;
      this.isLoading = true;
      this.fetchTableValueAPIData(this.pageSize, this.pageNumber);
      // this.searchTableValueData(this.pageSize, this.pageNumber);
    }
  }

  populateFilteredData(): Types.FilterRequest[] {
    if (this.filterService.getRefreshDataStatusValue()) {
      this.filterDataArray = this.filterService.getFilterConditionDataValue();
    }
    const { data, error } = transformTestToFilters(this.filterDataArray);
    const filterApplied = this.filterService.getFilterAppliedStatusValue();

    const filteredData: Types.FilterRequest[] = [...data];
    if (error && filterApplied) {
      // this.notificationService.error('Error in filters', 'Error in filters');
    }
    return filteredData;
  }

  // Method to fetch table value data
  fetchTableValueAPIData(pageSize: number, pageNumber: number): void {
    // Prevent multiple simultaneous calls
    if (this.isLoadingData || this.apiLoadingService.isComponentLoading('table')) {
      return;
    }

    // Additional check to ensure we're in the correct view
    if (!this._tableViewFlag()) {
      return;
    }

    this.tableViewBody.filters = this.populateFilteredData();
    this.tableViewBody.timeZone = this.sharedDataService.selectedTimezoneValue;

    this.isLoadingData = true;
    this.apiLoadingService.setLoading('table');

    if (this.tableViewBody.start_date && this._tableViewFlag()) {
      this.commonService.fetchTableValues(this.tableViewBody, pageSize, pageNumber).subscribe({
        next: (data: Types.RawTableType) => {
          // Clear loading state
          this.isLoadingData = false;
          this.apiLoadingService.setNotLoading('table');

          this.totalCount = this.sharedDataService.totalConversations;
          this.commonService.rowValue = this.sharedDataService.totalConversations;

          this.sharedDataService.setTotalCount(this.sharedDataService.totalConversations);
          const transformedData = convertConversationsToRowsColumns(data?.conversations);

          if (pageNumber === 1) {
            this.rows = transformedData.rows;
            // Clear selections when loading new data (page 1)
            this.clearSelections();
          } else {
            const rows = [...this.rows, ...transformedData.rows];
            this.rows = rows;
          }

          this.allRows = this.commonService.filteredDataSource;
          this.apiLoading = false;
          this.isLoading = false;
          this.isLoadingData = false;
          this.commonService.setLoaderFlag(false);
          this.loaderFlag = false;
          this.loadingMorePageData = false;
          this.filterService.setRefreshDataStatus(false);

        },
        error: (error) => {
          console.error('API Error:', error);
          this.apiLoading = false;
          this.isLoading = false;
          this.isLoadingData = false;
          this.loaderFlag = false;
          this.loadingMorePageData = false;
          this.commonService.setLoaderFlag(false);
          this.filterService.setRefreshDataStatus(false);
          this.apiLoadingService.setNotLoading('table');
        },
      });
    } else {
      this.loaderFlag = false;
      this.isLoadingData = false;
    }
  }

  exportPlot(): void {
    // Show persistent processing snackbar
    const processingSnackbarRef = this.snackBar.open('Exporting in progress...', '', {
      duration: undefined,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['processing-snackbar', 'custom-snackbar']
    });

    this.commonService.exportDataToCSV(this.tableViewBody).subscribe({
      next: (response) => {
        this.commonService.exportCSVDataResponse = response;

        // Start polling with snackbar reference
        this.exportCSVFileStatus(0, 0, 0, processingSnackbarRef);
      },
      error: (error) => {
        console.error('Export failed', error);
        processingSnackbarRef.dismiss();

        this.snackBar.open('Something went wrong. Please try again.', 'Close', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
          panelClass: ['error-snackbar', 'custom-snackbar']
        });
      },
    });
  }

  checkExportStatus(): void {
    this.exportCSVFileStatus();
  }


  exportCSVFileStatus(
    attempts: number = 0,
    retries: number = 0,
    failureCount: number = 0,
    snackbarRef?: MatSnackBarRef<any>
  ): void {
    const maxAttempts = 20;
    const maxRetries = 5;
    const maxFailures = 5;

    if (failureCount > maxFailures || retries >= maxRetries) {
      snackbarRef?.dismiss();
      this.snackBar.open('Something went wrong. Please try again.', 'Close', {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'top',
        panelClass: ['error-snackbar', 'custom-snackbar']
      });
      return;
    }

    if (attempts >= maxAttempts) {
      setTimeout(() => {
        this.exportCSVFileStatus(0, retries + 1, failureCount, snackbarRef);
      }, 6000);
      return;
    }

    this.commonService.exportCSVDataResponseStatus = false;

    this.commonService.exportDataToCSVFile(this.commonService.exportCSVDataResponse).subscribe({
      next: (responseStatus) => {
        const status = responseStatus as unknown as Types.CsvExportResponse;
        this.commonService.exportCSVDataResponseStatus = status.ready_to_download;

        if (status.ready_to_download === true) {
          snackbarRef?.dismiss(); // Close processing snackbar

          this.downloadFile(status.URL); // Download file

          this.snackBar.open('Export successful!', 'Close', {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
            panelClass: ['success-snackbar', 'custom-snackbar']
          });

          this.commonService.exportCSVDataResponseStatus = false;
        } else {
          setTimeout(() => {
            this.exportCSVFileStatus(attempts + 1, retries, failureCount, snackbarRef);
          }, 3000);
        }
      },
      error: (error) => {
        console.error('CSV Export Error:', error);
        const is504 = error?.status === 0;
        const updatedFailureCount = is504 ? failureCount : failureCount + 1;

        if (updatedFailureCount > maxFailures) {
          snackbarRef?.dismiss();
          this.snackBar.open('Something went wrong. Please try again.', 'Close', {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
            panelClass: ['error-snackbar', 'custom-snackbar']
          });
        } else {
          setTimeout(() => {
            this.exportCSVFileStatus(attempts + 1, retries, updatedFailureCount, snackbarRef);
          }, 6000);
        }
      },
    });
  }

  downloadFile(data: string): void {
    const anchor = document.createElement('a');
    anchor.href = data;
    const timestamp = this.getCurrentTimestamp();
    const filename = `Data_${timestamp}.csv`;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    this.notificationService.success('export', 'Data Exported.');
  }

  private getCurrentTimestamp(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  }

  selected: any = 5;
  ngAfterViewInitCalled = false;

  getHeaderNames(headers: any): string[] {
    return headers.map((header: any) => header.name);
  }

  filterData(dataSource: MatTableDataSource<any>, searchText: any) {
    const columnsToFilter = this.sharedDataService.getColumnNamesValue().map((nameObj) => nameObj.key);
    const array = this.commonService.dataSource.data;

    return array.filter((obj: any) => {
      return columnsToFilter.some((key) => {
        if (obj[key] && typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searchText.toLowerCase())) {
          return true;
        }
        return false;
      });
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    const filteredData = this.filterData(this.commonService.dataSource, filterValue);
    this.commonService.filteredDataSource.data = filteredData;

    if (this.commonService.filteredDataSource.paginator) {
      this.commonService.filteredDataSource.paginator.firstPage();
    }
  }

  convertToNumber(value: string | number): number {
    return typeof value === 'string' ? parseInt(value, 10) : value;
  }

  parseSeconds(value: any): number {
    if (typeof value === 'string') {
      value = value.trim();
    }
    const num = typeof value === 'string' ? parseInt(value, 10) : value;
    return isNaN(num) ? NaN : num;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  trackByFn(index: number, item: any): any {
    return item.id || index; // use a unique id for better performance
  }

  visibleDataSource: any[] = [];
  allRows: any[] = []; // This will hold all the data

  // Selection properties
  selectedRows: Set<string> = new Set();
  maxSelections: number = 50;
  private readonly STORAGE_KEY = 'tabularViewSelectedContactIds';
  private readonly STORAGE_TIMESTAMP_KEY = 'tabularViewSelectionTimestamp';
  hoveredRows: Set<string> = new Set(); // Track hovered rows

  onRowVisible(isVisible: boolean, row: any) {
    if (isVisible && !this.visibleDataSource.includes(row)) {
      this.visibleDataSource.push(row); // Add row to visible data source when it enters the viewport
    }
  }

  // Selection methods
  onRowSelect(row: any, checked: boolean): void {
    const contactId = row['ContactId'];
    if (!contactId) {
      // console.warn('Row does not have ContactId:', row);
      return;
    }

    if (checked) {
      if (this.selectedRows.size >= this.maxSelections) {
        this.notificationService.error('Selection Limit', `Maximum ${this.maxSelections} selections allowed`);
        return;
      }
      this.selectedRows.add(contactId);
    } else {
      this.selectedRows.delete(contactId);
    }

    // Save to localStorage after each selection change
    this.saveSelectionToSession();
  }

  onSelectAll(checked: boolean): void {
    if (checked) {
      // Select latest 50 rows
      const latestRows = this.rows.slice(0, this.maxSelections);
      this.selectedRows.clear();
      latestRows.forEach(row => {
        const contactId = row['ContactId'];
        if (contactId) {
          this.selectedRows.add(contactId);
        }
      });
    } else {
      this.selectedRows.clear();
    }

    // Save to localStorage after bulk selection change
    this.saveSelectionToSession();
  }

  isRowSelected(row: any): boolean {
    const contactId = row['ContactId'];
    return contactId ? this.selectedRows.has(contactId) : false;
  }

  isAllSelected(): boolean {
    return this.rows.length > 0 && this.selectedRows.size === Math.min(this.rows.length, this.maxSelections);
  }

  isIndeterminate(): boolean {
    return this.selectedRows.size > 0 && this.selectedRows.size < Math.min(this.rows.length, this.maxSelections);
  }

  openInPlayground(): void {
    if (this.selectedRows.size === 0) {
      this.toastr.warning('Please select at least one row');
      return;
    }

    const selectedContactIds = Array.from(this.selectedRows);

    // Navigate to playground with selected contact IDs
    this.toastr.success(`${selectedContactIds.length} contact IDs selected for playground`);

    // Navigate to the playground page
    // You can use Angular Router to navigate to the playground
    // For now, we'll use a simple approach by setting a flag in localStorage
    try {
      sessionStorage.setItem('navigateToPlayground', 'true');
    } catch (e) {
      console.warn('Could not set navigateToPlayground in sessionStorage', e);
    }
  }

  getSelectedCount(): number {
    return this.selectedRows.size;
  }

  // Clear selections when data changes
  clearSelections(): void {
    this.selectedRows.clear();
    this.hoveredRows.clear();
    this.clearSelectionFromSession();
  }

  // Public method to clear selections and localStorage
  clearAllSelections(): void {
    this.selectedRows.clear();
    this.hoveredRows.clear();
    this.clearSelectionFromSession();
  }

  /** Persist selection to sessionStorage (Insights Dashboard – cleared when tab closes). */
  private saveSelectionToSession(): void {
    try {
      const selectedContactIds = Array.from(this.selectedRows);
      const selectionData = {
        contactIds: selectedContactIds,
        timestamp: new Date().toISOString(),
        count: selectedContactIds.length
      };
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(selectionData));
      sessionStorage.setItem(this.STORAGE_TIMESTAMP_KEY, new Date().toISOString());
      this.dispatchStorageEvent('selectionUpdated', selectionData);
    } catch (error) {
      console.error('Error saving selection to sessionStorage:', error);
    }
  }

  private loadSelectionFromSession(): void {
    try {
      const storedData = sessionStorage.getItem(this.STORAGE_KEY);
      if (storedData) {
        const selectionData = JSON.parse(storedData);
        if (selectionData?.contactIds && Array.isArray(selectionData.contactIds)) {
          this.selectedRows = new Set(selectionData.contactIds);
        }
      }
    } catch (error) {
      this.selectedRows.clear();
    }
  }

  private clearSelectionFromSession(): void {
    try {
      sessionStorage.removeItem(this.STORAGE_KEY);
      sessionStorage.removeItem(this.STORAGE_TIMESTAMP_KEY);
      this.dispatchStorageEvent('selectionCleared', null);
    } catch (error) {
      console.error('Error clearing selection from sessionStorage:', error);
    }
  }

  private dispatchStorageEvent(action: string, data: any): void {
    try {
      const event = new CustomEvent('tabularViewSelectionChange', {
        detail: {
          action,
          data,
          timestamp: new Date().toISOString()
        }
      });
      window.dispatchEvent(event);
    } catch (error) {
      console.error('Error dispatching storage event:', error);
    }
  }

  // Cross-tab communication setup
  private setupCrossTabCommunication(): void {
    // Listen for storage changes from other tabs
    window.addEventListener('storage', (event) => {
      if (event.key === this.STORAGE_KEY || event.key === this.STORAGE_TIMESTAMP_KEY) {
        this.handleStorageChange(event);
      }
    });

    // Listen for custom events from same tab
    window.addEventListener('tabularViewSelectionChange', (event: any) => {
      this.handleCustomStorageEvent(event.detail);
    });
  }

  private handleStorageChange(event: StorageEvent): void {
    if (event.key === this.STORAGE_KEY) {
      if (event.newValue) {
        try {
          const selectionData = JSON.parse(event.newValue);
          if (selectionData && selectionData.contactIds) {
            this.selectedRows = new Set(selectionData.contactIds);
          }
        } catch (error) {
          console.error('Error parsing storage change:', error);
        }
      } else {
        this.selectedRows.clear();
        this.hoveredRows.clear();
      }
    }
  }

  private handleCustomStorageEvent(eventDetail: any): void {
    if (eventDetail.action === 'selectionUpdated') {
      if (eventDetail.data && eventDetail.data.contactIds) {
        this.selectedRows = new Set(eventDetail.data.contactIds);
      }
    } else if (eventDetail.action === 'selectionCleared') {
      this.selectedRows.clear();
      this.hoveredRows.clear();
    }
  }

  // Public method to get selected Contact IDs for external use
  getSelectedContactIds(): string[] {
    return Array.from(this.selectedRows);
  }

  // Public method to check if there are any selections
  hasSelections(): boolean {
    return this.selectedRows.size > 0;
  }

  // Hover methods
  onRowHover(row: any, isHovered: boolean): void {
    const contactId = row['ContactId'];
    if (!contactId) return;

    if (isHovered) {
      this.hoveredRows.add(contactId);
    } else {
      this.hoveredRows.delete(contactId);
    }
  }

  isRowHovered(row: any): boolean {
    const contactId = row['ContactId'];
    return contactId ? this.hoveredRows.has(contactId) : false;
  }

  getRowClass = (row: any) => {
    const contactId = row['ContactId'];
    if (contactId && this.selectedRows.has(contactId)) {
      return 'selected-row';
    }
    return '';
  }
}
